import { JOBS_URL } from '@/utils/constants'

const ISSUES = () => `${JOBS_URL}`
const ISSUE_BY_ID = (id: string) => `${ISSUES()}/${id}`

export default {
  ISSUES,
  ISSUE_BY_ID
}
